export default "__VITE_ASSET__e53ea5a5__"